import React, { useState, useEffect } from 'react';
import { getOccupations } from '../../services/api';

export default function OcupationEntry({ onOcupationChange }) {
  const [selectedOcupation, setSelectedOcupation] = useState('');
  const [occupations, setOccupations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOccupations = async () => {
      try {
        const response = await getOccupations();
        setOccupations(response);
      } catch (error) {
        console.error('Error fetching occupations:', error);
        // Fallback a opciones hardcodeadas
        setOccupations([
          { id_ocupacion: '1', ocupation: 'Empleado' },
          { id_ocupacion: '2', ocupation: 'Empresario' },
          { id_ocupacion: '3', ocupation: 'Estudiante' },
          { id_ocupacion: '4', ocupation: 'Profesionista Independiente' },
          { id_ocupacion: '5', ocupation: 'Jubilado' },
          { id_ocupacion: '6', ocupation: 'Otro' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchOccupations();
  }, []);

  useEffect(() => {
    if (onOcupationChange) {
      onOcupationChange(selectedOcupation);
    }
  }, [selectedOcupation, onOcupationChange]);

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando ocupaciones...
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={selectedOcupation}
        onChange={e => setSelectedOcupation(e.target.value)}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none bg-white"
      >
        <option value="" disabled>
          Seleccione Ocupación
        </option>
        {occupations.map(occupation => (
          <option key={occupation.id_ocupacion} value={occupation.id_ocupacion}>
            {occupation.ocupation}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
}
